import React from 'react'
import { Flex, Hide, LayoutGrid } from '../primitives/Layout'
import { CollapsibleNav, CollapsibleNavTrigger } from '../shared/CollapsibleNav'
import { SharedLayout } from '../shared/SharedLayout'
import { useAppIcons } from '../utils/useAppIcons'
import DocsContent from './Content'
import { DocsSearch } from './DocsSearch'
import Nav from './Nav'
import { SkipToContent } from './SkipLink'
import { useScrollRestoration } from './useScrollRestoration'

export const DocsContainer = ({ category, section, title, slug, children }) => {
  const appIcons = useAppIcons()
  const { ref: scrollRef, onScroll } = useScrollRestoration(slug)

  return (
    <Flex
      width="100%"
      flexDirection="column"
      css={{
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: '100svh'
      }}
      pt={5}
      ref={scrollRef}
      onScroll={onScroll}
    >
      <SharedLayout appIcons={appIcons} bg="white">
        <SkipToContent />

        <LayoutGrid
          px={[3, 3, 4, 4, 4, 0]}
          pb="15svh"
          width="100%"
          alignItems="start"
          maxWidth="var(--bnb-container-width)"
          mx="auto"
        >
          <Flex
            gridColumn={['1 / -1', '1 / span 2', '1 / span 3']}
            position={['relative', 'relative', 'sticky']}
            top={[0, 0, 0]}
            alignSelf="start"
          >
            <Hide m l width="100%" flexDirection="column">
              <CollapsibleNav Trigger={NavTrigger}>
                <Nav
                  slug={slug}
                  category={category}
                  section={section}
                  title={title}
                  px={3}
                  pt={2}
                  pb={3}
                />
              </CollapsibleNav>
            </Hide>

            <Hide xs s width="100%">
              <Nav
                slug={slug}
                category={category}
                section={section}
                title={title}
              />
            </Hide>
          </Flex>

          <Flex
            as="main"
            gridColumn={['1 / -1', '3 / -1', '4 / -1']}
            flexDirection="column"
          >
            <Hide m l width="100%">
              <DocsSearch />
            </Hide>

            {children}
          </Flex>
        </LayoutGrid>
      </SharedLayout>
    </Flex>
  )
}

const NavTrigger = () => {
  return <CollapsibleNavTrigger>Support Topics</CollapsibleNavTrigger>
}

const Docs = ({
  children,
  title,
  section,
  category,
  tableOfContents,
  slug,
  platforms,
  updatedFormatted,
  relatedArticles,
  faqs
}) => (
  <DocsContent
    title={title}
    slug={slug}
    baseURL="support"
    category={category}
    section={section}
    tableOfContents={tableOfContents}
    platforms={platforms}
    updatedFormatted={updatedFormatted}
    relatedArticles={relatedArticles}
    faqs={faqs}
  >
    {children}
  </DocsContent>
)

export default Docs
